var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass: "navbar has-shadow",
      attrs: { role: "navigation", "aria-label": "main navigation" }
    },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "navbar-brand" },
          [
            _c(
              "router-link",
              {
                staticClass: "navbar-item has-text-weight-bold has-icon",
                attrs: { to: "/doctor/login" }
              },
              [
                _c("span", [_vm._v("Tooddoc")]),
                _vm._v(" "),
                _vm.FIREBASE_PROJECT_ID == "tooddoc-dev"
                  ? _c(
                      "span",
                      {
                        staticClass: "tag is-primary ml-1",
                        staticStyle: { "font-size": "0.5rem" }
                      },
                      [_vm._v("DEV")]
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "navbar-item is-hidden-desktop v-flex" }, [
              _c(
                "p",
                { staticClass: "control is-fullwidth has-text-right" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass:
                        "is-hidden-mobile button is-primary is-outlined mr-2",
                      attrs: { to: { name: "doctor.profile" } }
                    },
                    [
                      _vm.doctor
                        ? _c("avatar", {
                            staticClass: "mr-2",
                            attrs: {
                              avatar: _vm.doctor.avatar,
                              name:
                                _vm.doctor.firstName + " " + _vm.doctor.lastName
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("my_profile_link_label")))
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button is-danger",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.logout($event)
                        }
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("logout_link_label")))])]
                  )
                ],
                1
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "navbar-menu" }, [
          _c(
            "div",
            { staticClass: "navbar-start" },
            [
              _c(
                "router-link",
                {
                  staticClass: "navbar-item",
                  attrs: { to: { name: "doctor.dashboard" } }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("dashboard_link_label")) +
                      "\n                "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "navbar-item",
                  attrs: { to: { name: "doctor.availabilities" } }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("my_availabilities_link_label")) +
                      "\n                "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "navbar-item",
                  attrs: { to: { name: "doctor.emergencies" } }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("find_emergencies_link_label")) +
                      "\n                "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "navbar-end" }, [
            _c("div", { staticClass: "navbar-item" }, [
              _c(
                "p",
                { staticClass: "control" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "button is-primary is-outlined mr-2",
                      attrs: { to: { name: "doctor.profile" } }
                    },
                    [
                      _vm.doctor
                        ? _c("avatar", {
                            staticClass: "mr-2",
                            attrs: {
                              avatar: _vm.doctor.avatar,
                              name:
                                _vm.doctor.firstName + " " + _vm.doctor.lastName
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("my_profile_link_label")))
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button is-danger",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.logout($event)
                        }
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("logout_link_label")))])]
                  )
                ],
                1
              )
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58928d52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58928d52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Doctor/AppNav.vue
// module id = 613
// module chunks = 1